<template>
  <ul class="product-options" :class="{'product-options--product-card': isProductCard}">
    <ProductOption v-for="(option, i) in computedOptions"
                   :link="link"
                   :key="i"
                   :data="option"
                   :is-product-card="isProductCard"
                   class="product-options__item" />
  </ul>
</template>

<script>
import ProductOption from '@/components/product/product-options/ProductOption'

export default {
  name: 'ProductOptions',
  components: {
    ProductOption
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    isProductCard: {
      type: Boolean,
      default: false
    },
    link: String
  },
  computed: {
    computedOptions () {
      return this.isProductCard ? this.options.slice(0, 1) : this.options
    }
  }
}
</script>

<style scoped lang="sass">

.product-options
  +list-unstyled
  margin-bottom: 12px

  &--product-card
    order: -1
    margin-bottom: 7px
    margin-top: 5px
    margin-left: 130px

    +mmin($tablet)
      order: initial
      margin-bottom: 12px
      margin-top: 20px
      margin-left: 0

.product-card--not--adaptive .product-options
  display: none

  +mmin($tablet)
    display: block

</style>
